import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateApproveModerationVacancy = {
  approveModerationVacancy: { data: null, loading: false, error: null },
};

export const approveModerationVacancy = createAsyncThunk('user/approveModerationVacancy', async (vacancyIds, { rejectWithValue, fulfillWithValue }) => {
  const vacancies = Array.isArray(vacancyIds) ? vacancyIds : [vacancyIds];
  return await axiosInstance
    .post(
      `${process.env.REACT_APP_SERVER_API}/vacancies/moderation/approve`,
      { vacancies },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerApproveModerationVacancy = {
  [approveModerationVacancy.pending]: (state) => {
    state.approveModerationVacancy.loading = true;
    state.approveModerationVacancy.error = null;
  },
  [approveModerationVacancy.fulfilled]: (state, action) => {
    state.approveModerationVacancy.loading = false;
    state.approveModerationVacancy.data = true;
    state.approveModerationVacancy.error = null;
  },
  [approveModerationVacancy.rejected]: (state, action) => {
    state.approveModerationVacancy.loading = false;
    state.approveModerationVacancy.error = action.payload;
  },
};
